export const coachingFAQData = [
  {
    question: "Was ist der Unterschied zwischen Finanzcoaching und Finanzberatung?",
    answer: "Finanzcoaching fokussiert sich auf Ihre persönliche Entwicklung und Selbstbestimmung. Als Coach begleite ich Sie dabei, eigene finanzielle Entscheidungen zu treffen, anstatt Ihnen Produkte zu verkaufen oder konkrete Anlageempfehlungen zu geben."
  },
  {
    question: "Für wen ist Finanzcoaching geeignet?",
    answer: "Finanzcoaching eignet sich für Menschen, die langfristig finanziell unabhängig werden möchten, ihr Finanzverhalten verstehen wollen und selbstbestimmte Entscheidungen treffen möchten - ohne Produktverkauf."
  },
  {
    question: "Wie läuft ein Finanzcoaching ab?",
    answer: "Im Coaching analysieren wir gemeinsam Ihre finanzielle Situation, arbeiten an limitierenden Glaubenssätzen und entwickeln individuelle Strategien. Sie erhalten praktisches Finanzwissen und werden befähigt, eigene Entscheidungen zu treffen."
  },
  {
    question: "Was kostet ein Finanzcoaching?",
    answer: "Finanzcoaching wird honorarbasiert abgerechnet, nicht provisionsbasiert. Dadurch entstehen keine Interessenkonflikte. Genaue Preise finden Sie auf der Preise-Seite oder wir besprechen sie im kostenlosen Erstgespräch."
  },
  {
    question: "Wo findet das Coaching statt?",
    answer: "Das Coaching kann online, in meinen Räumlichkeiten oder als besonderes Walk & Talk Format am Rothsee in der Natur stattfinden. Die Wahl des Formats richtet sich nach Ihren Präferenzen."
  }
];